<template>
    <div
        id="modal-asset-form"
        class="modal fade"
        tabindex="-1"
        role="dialog"
        style="display: none;">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header flex items-center justify-between">
                    <h4 class="modal-title font-medium" id="modalTitle">
                        {{ modalTitle }}
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                </div>

                <div class="modal-body">
                    <form class="form">
                        <!--Asset Form Fields-->
                        <div v-if="section === 0">
                            <div class="form-group">
                                <label for="asset_name">Name</label>
                                <input class="form-control" type="text" id="asset_name" name="asset_name"
                                       v-model="form.asset_name" placeholder="25 Koeberg Road"
                                       :class="{'is-invalid': form.errors.has('asset_name')}">

                                <span class="invalid-feedback" v-show="form.errors.has('asset_name')">
                                    {{ form.errors.get("asset_name") }}
                                </span>
                            </div>

                            <div class="form-group">
                                <label class="font-normal">Mandate Type</label>
                                <div id="mandate_type" class="w-full">
                                    <el-select v-model="form.current_mandate_type" placeholder="Select Mandate Type" class="w-full">
                                        <el-option key="managed" label="Managed" value="managed"></el-option>
                                        <el-option key="unmanaged" label="Unmanaged" value="unmanaged"></el-option>
                                    </el-select>
                                </div>

                                <span class="invalid-feedback" :class="{'d-block': form.errors.has('current_mandate_type')}"
                                      v-show="form.errors.has('current_mandate_type')">
                                    {{ form.errors.get("current_mandate_type") }}
                                </span>
                            </div>

                            <!--Portfolio Selection-->
                            <div class="form-group">
                                <label for="portfolio">Portfolio</label>
                                <div id="portfolio">
                                    <el-select style="width:100%" v-model="form.portfolio"
                                               placeholder="Select portfolio">
                                        <el-option
                                            v-for="item in app.state.user.portfolios"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>

                                <span class="invalid-feedback" :class="{'d-block': form.errors.has('portfolio')}"
                                      v-show="form.errors.has('portfolio')">
                                    {{ form.errors.get("portfolio") }}
                                </span>
                            </div>

                            <!--Asset Group Selection-->
                            <div class="form-group">
                                <label class="w-100" for="asset_group">Asset Group</label>
                                <div id="asset_group">

                                    <remote-select
                                        v-model="selectedAssetGroup"
                                        @focus="searchAssetGroups"
                                        :remote-method="searchAssetGroups"
                                        @input="assetGroupChanged"
                                        :data="assetGroups"
                                        :loading="loading"
                                        class="w-full"
                                        item-label="name"
                                        placeholder="Select Asset Group / Complex (Optional)">
                                        <template slot-scope="props">
                                            {{ props.item.name }}
                                        </template>
                                    </remote-select>
                                </div>

                                <span class="invalid-feedback" :class="{'d-block': form.errors.has('asset_group')}"
                                      v-show="form.errors.has('asset_group')">
                                    {{ form.errors.get("asset_group") }}
                                </span>
                            </div>
                        </div>

                        <!--Address Fields-->
                        <div v-if="section === 1">
                            <!--Address Line 1-->
                            <div class="form-group">
                                <label for="address_line_1">Address line 1</label>
                                <input
                                    class="form-control"
                                    type="text"
                                    id="address_line_1"
                                    name="address_line_1"
                                    v-model="form.address_line_1"
                                    :class="{'is-invalid': form.errors.has('address_line_1')}"/>

                                <span class="invalid-feedback" v-show="form.errors.has('address_line_1')">
                                    {{ form.errors.get("address_line_1") }}
                                </span>
                            </div>

                            <!--Address Line 2-->
                            <div class="form-group">
                                <label for="address_line_2">Address line 2</label>
                                <input
                                    class="form-control"
                                    type="text"
                                    id="address_line_2"
                                    name="address_line_2"
                                    v-model="form.address_line_2"
                                    :class="{'is-invalid': form.errors.has('address_line_2')}"/>

                                <span class="invalid-feedback" v-show="form.errors.has('address_line_2')">
                                    {{ form.errors.get("address_line_2") }}
                                </span>
                            </div>

                            <!--Address Line 3-->
                            <div class="form-group">
                                <label for="address_line_3">Address line 3</label>
                                <input
                                    class="form-control"
                                    type="text"
                                    id="address_line_3"
                                    name="address_line_3"
                                    v-model="form.address_line_3"
                                    :class="{'is-invalid': form.errors.has('address_line_3')}"/>

                                <span class="invalid-feedback" v-show="form.errors.has('address_line_3')">
                                    {{ form.errors.get("address_line_3") }}
                                </span>
                            </div>

                            <!--City-->
                            <div class="form-group">
                                <label for="city">City</label>
                                <input
                                    class="form-control"
                                    type="text"
                                    id="city"
                                    name="city"
                                    v-model="form.city"
                                    :class="{'is-invalid': form.errors.has('city')}"/>

                                <span class="invalid-feedback" v-show="form.errors.has('city')">
                                    {{ form.errors.get("city") }}
                                </span>
                            </div>

                            <!--State/Province/Region-->
                            <div class="form-group">
                                  <label for="state_province_region">Province</label>
                                  <el-select
                                          class="w-100"
                                          :class="{'invalid-feedback': form.errors.has('state_province_region')}"
                                          v-model="form.state_province_region"
                                          placeholder="Select Province">
                                      <el-option v-for="province in provinces" :key="province" :value="province"></el-option>
                                  </el-select>

                                  <span
                                          class="invalid-feedback"
                                          :class="{'d-block': form.errors.has('state_province_region')}"
                                          v-show="form.errors.has('state_province_region')"
                                  >
                                      {{ form.errors.get('state_province_region') }}
                                  </span>
                            </div>
                            <!--Zip / Postal Code-->
                            <div class="form-group">
                                <label for="zip_postal_code">Zip / Postal Code</label>
                                <input
                                    class="form-control"
                                    type="text"
                                    id="zip_postal_code"
                                    name="zip_postal_code"
                                    v-model="form.zip_postal_code"
                                    :class="{'is-invalid': form.errors.has('zip_postal_code')}"/>

                                <span class="invalid-feedback" v-show="form.errors.has('zip_postal_code')">
                                    {{ form.errors.get("zip_postal_code") }}
                                </span>
                            </div>
                        </div>

                        <!--Contact Links & Dates-->
                        <div v-if="section === 2">
                            <contact-link-list
                                v-model="form.contact_links"
                                contactable-type="asset"
                                :roles="['landlord', 'tenant', 'other']"
                                :show-dates-for="['tenant']"
                            ></contact-link-list>
                        </div>
                    </form>
                </div>

                <!--Buttons-->
                <div v-if="!creatingNewContact" class="flex items-center mx-2 my-4" :class="[section === 0 ? 'justify-end' : 'justify-between']">
                    <!--Previous-->
                    <button type="button"
                            v-if="section === 1 || section === 2"
                            @click.prevent="previousSection"
                            :disabled="form.busy"
                            class="select-none sm:ml-2 px-4 py-2 border border-gray-300 text-gray-700 shadow-sm hover:text-gray-500 text-sm font-medium rounded-md shadow text-white hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:ring focus:ring-blue-400 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                        Back
                    </button>

                    <div class="flex items-center mx-2">
                        <!--Next / Create Asset-->
                        <button
                            class="select-none sm:ml-2 px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow text-white bg-indigo-600 hover:bg-indigo-700"
                            @click.prevent="section === 2 ? create() : nextSection()"
                            :disabled="form.busy">
                            {{ section === 2 ? (form.busy ? "Creating Asset..." : "Create Asset") : "Next" }}
                        </button>

                        <!--Cancel-->
                        <button
                            type="button"
                            class="select-none sm:ml-2 px-4 py-2 border border-gray-300 text-gray-700 shadow-sm hover:text-gray-500 text-sm font-medium rounded-md shadow text-white hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:ring focus:ring-blue-400 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                            data-dismiss="modal"
                            :disabled="form.busy">
                            Cancel
                        </button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

import AssetGroupSearch from "../../mixins/asset-group-search";

export default {
    name: "CreateAsset",
    mixins: [AssetGroupSearch],
    data () {
        return {
            form: {},
            section: 0,
            creatingNewContact: false,
            selectedAssetGroup: null,
            provinces: ['Eastern Cape', 'Free State', 'Gauteng', 'KwaZulu-Natal', 'Limpopo', 'Mpumalanga', 'Northern Cape', 'North West', 'Western Cape']
        };
    },

    created () {
        this.initialiseForm();
    },

    mounted () {
        let self = this;
        Bus.$on("creating-new-contact", function (bool) {
            self.creatingNewContact = bool;
        });
    },

    computed: {
        modalTitle () {
            switch (this.section) {
                case 1: {
                    return "Full Address Details";
                }
                case 2: {
                    return this.creatingNewContact ? "Create New Contact" : "Contacts";
                }
                default:
                    return "New Property Details";
            }
        },
    },

    methods: {
        initialiseForm () {
            this.form = new AppForm({
                portfolio: this.app.state.user.portfolios[0].id,
                mandate_type: "managed"
            });
        },

        create () {
            this.form.asset_group = this.selectedAssetGroup?.id;

            App.post("/assets/create", this.form)
            .then(() => {
                this.initialiseForm();
                Bus.$emit("asset-created");
                window.toastr.success("Asset created!");
                this.section = 0;
                this.app.state.assets_remaining -= 1;

            })
            .catch(() => {
                this.section = 0;
            });

            this.selectedAssetGroup = null;
        },

        assetGroupChanged () {
            this.setAddress(this.selectedAssetGroup);
        },

        setAddress (assetGroup = null) {
            this.form.address_line_1 = assetGroup?.address_line_1;
            this.form.address_line_2 = assetGroup?.address_line_2;
            this.form.address_line_3 = assetGroup?.address_line_3;
            this.form.city = assetGroup?.city;
            this.form.zip_postal_code = assetGroup?.zip_postal_code;
            this.$set(this.form, 'state_province_region', assetGroup?.state_province_region);
        },

        nextSection () {
            this.section = this.section + 1;
        },

        previousSection () {
            this.section = this.section - 1;
        },
    },
};
</script>

<style scoped>

</style>
